const head = document.getElementsByTagName("head")[0];

function renameSite(titlePages) {
  const title = head.getElementsByTagName("title")[0];
  title.innerHTML = titlePages;
}

export default renameSite;
